document.addEventListener('DOMContentLoaded', function () {
  var nameField = document.querySelector('[data-abh-name]');
  var hoursRoot = document.querySelector('[id^="abh-hours-"]');
  if (!nameField && !hoursRoot) return;

  var form =
    document.getElementById(nameField && nameField.getAttribute('form')) ||
    document.getElementById(hoursRoot && hoursRoot.getAttribute('data-abh-form')) ||
    document.querySelector('form[data-type="add-to-cart-form"]');

  var TIMES = hoursRoot
    ? (hoursRoot.getAttribute('data-abh-times') || '').split(',').filter(Boolean)
    : [];

  function syncHidden(name, value) {
    if (!form) return;
    var existing = form.querySelector('input[data-abh-cart="' + name + '"]');
    if (!existing) {
      existing = document.createElement('input');
      existing.type = 'hidden';
      existing.name = name;
      existing.setAttribute('data-abh-cart', name);
      form.appendChild(existing);
    }
    existing.value = value;
    existing.disabled = !value;
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function formatTime(hours24, minutes) {
    var suffix = hours24 >= 12 ? 'pm' : 'am';
    var hours12 = hours24 % 12;
    if (hours12 === 0) hours12 = 12;
    return hours12 + ':' + pad(minutes) + suffix;
  }

  function parseTime(raw, fallbackMeridiem) {
    if (!raw) return null;
    var text = String(raw).trim().toLowerCase().replace(/\s+/g, '').replace('.', ':');
    var match = text.match(/^(\d{1,2})(?::(\d{2}))?(am|pm)?$/);
    if (!match) return null;
    var hour = parseInt(match[1], 10);
    var minutes = match[2] ? parseInt(match[2], 10) : 0;
    var suffix = match[3] || '';
    if (hour > 23 || minutes > 59) return null;
    if (!suffix && hour > 12) {
      return formatTime(hour, minutes);
    }
    if (!suffix && hour === 12) suffix = 'pm';
    if (!suffix) suffix = fallbackMeridiem === 'pm' ? 'pm' : 'am';
    if (hour > 12) return null;
    if (hour === 0) hour = 12;
    var hours24 = hour % 12;
    if (suffix === 'pm') hours24 += 12;
    return formatTime(hours24, minutes);
  }

  function fieldValue(input) {
    if (!input) return '';
    var fallback = input.getAttribute('data-abh-meridiem') || 'am';
    return parseTime(input.value, fallback) || input.value.trim();
  }

  function groupValue(row) {
    if (row.classList.contains('is-closed')) return 'Closed';
    var open = row.querySelector('[data-abh-open]');
    var close = row.querySelector('[data-abh-close]');
    if (!open || !close) return '';
    var openValue = fieldValue(open);
    var closeValue = fieldValue(close);
    if (!openValue || !closeValue) return '';
    return openValue + ' – ' + closeValue;
  }

  function isGrouped() {
    return !!(hoursRoot && hoursRoot.classList.contains('is-grouped'));
  }

  function copyLeadToFollowers() {
    if (!hoursRoot || !isGrouped()) return;
    var lead = hoursRoot.querySelector('.abh-hours-row--lead');
    if (!lead) return;
    var leadOpen = lead.querySelector('[data-abh-open]');
    var leadClose = lead.querySelector('[data-abh-close]');
    var closed = lead.classList.contains('is-closed');
    hoursRoot.querySelectorAll('.abh-hours-row--follow').forEach(function (row) {
      var open = row.querySelector('[data-abh-open]');
      var close = row.querySelector('[data-abh-close]');
      if (open && leadOpen) open.value = leadOpen.value;
      if (close && leadClose) close.value = leadClose.value;
      row.classList.toggle('is-closed', closed);
      var closedBtn = row.querySelector('[data-abh-closed]');
      if (closedBtn) closedBtn.classList.toggle('is-active', closed);
      if (open) open.disabled = closed;
      if (close) close.disabled = closed;
    });
  }

  function syncHours() {
    if (!hoursRoot) return;
    copyLeadToFollowers();
    var lines = [];
    hoursRoot.querySelectorAll('[data-abh-group]').forEach(function (row) {
      var value = groupValue(row);
      row.getAttribute('data-abh-days').split(',').forEach(function (day) {
        var hidden = hoursRoot.querySelector('[data-abh-day="' + day + '"]');
        if (hidden) hidden.value = value;
        syncHidden('properties[' + day + ']', value);
        if (value) lines.push(day + ': ' + value);
      });
    });
    syncHidden('properties[Opening hours]', lines.join(' · '));
  }

  function syncCartProperties() {
    if (nameField) syncHidden('properties[Business name]', nameField.value.trim());
    syncHours();
  }

  function setClosed(row, closed) {
    row.classList.toggle('is-closed', closed);
    var closedBtn = row.querySelector('[data-abh-closed]');
    var open = row.querySelector('[data-abh-open]');
    var close = row.querySelector('[data-abh-close]');
    if (closedBtn) closedBtn.classList.toggle('is-active', closed);
    if (open) open.disabled = closed;
    if (close) close.disabled = closed;
    syncCartProperties();
  }

  function setMode(mode) {
    if (!hoursRoot) return;
    var grouped = mode === 'grouped';
    hoursRoot.classList.toggle('is-grouped', grouped);
    hoursRoot.querySelectorAll('[data-abh-mode]').forEach(function (button) {
      var active = button.getAttribute('data-abh-mode') === mode;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    syncCartProperties();
  }

  function closeAllCombos() {
    if (!hoursRoot) return;
    hoursRoot.querySelectorAll('[data-abh-combo]').forEach(function (combo) {
      var list = combo.querySelector('[data-abh-combo-list]');
      var input = combo.querySelector('input');
      if (list) list.hidden = true;
      if (input) input.setAttribute('aria-expanded', 'false');
    });
  }

  function filterTimes(query) {
    var needle = String(query || '').trim().toLowerCase().replace(/\s+/g, '');
    if (!needle) return TIMES.slice();
    return TIMES.filter(function (time) {
      return time.toLowerCase().replace(/\s+/g, '').indexOf(needle) !== -1;
    });
  }

  function renderList(combo, query) {
    var list = combo.querySelector('[data-abh-combo-list]');
    var input = combo.querySelector('input');
    if (!list || !input) return;
    var matches = filterTimes(query);
    list.innerHTML = '';
    if (!matches.length) {
      var empty = document.createElement('li');
      empty.className = 'abh-hours-combo-empty';
      empty.textContent = 'Keep typing your time';
      list.appendChild(empty);
    } else {
      matches.forEach(function (time) {
        var item = document.createElement('li');
        item.setAttribute('role', 'option');
        item.className = 'abh-hours-combo-option';
        item.setAttribute('data-value', time);
        item.textContent = time;
        if (time === input.value) item.classList.add('is-selected');
        list.appendChild(item);
      });
    }
    list.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function openCombo(combo) {
    if (!combo) return;
    var input = combo.querySelector('input');
    if (!input || input.disabled) return;
    closeAllCombos();
    if (!combo.querySelector('[data-abh-combo-list]')) {
      var list = document.createElement('ul');
      list.className = 'abh-hours-combo-list';
      list.setAttribute('data-abh-combo-list', '');
      list.setAttribute('role', 'listbox');
      combo.appendChild(list);
    }
    renderList(combo, input.value);
  }

  function commitInput(input) {
    if (!input || input.disabled) return;
    var next = parseTime(input.value, input.getAttribute('data-abh-meridiem') || 'am');
    if (next) input.value = next;
    syncCartProperties();
  }

  if (hoursRoot) {
    hoursRoot.querySelectorAll('[data-abh-mode]').forEach(function (button) {
      button.addEventListener('click', function () {
        setMode(button.getAttribute('data-abh-mode'));
      });
    });

    hoursRoot.querySelectorAll('[data-abh-group]').forEach(function (row) {
      var closedBtn = row.querySelector('[data-abh-closed]');
      if (closedBtn) {
        closedBtn.addEventListener('click', function () {
          setClosed(row, !row.classList.contains('is-closed'));
        });
      }
    });

    hoursRoot.querySelectorAll('[data-abh-combo]').forEach(function (combo) {
      var input = combo.querySelector('input');
      var toggle = combo.querySelector('[data-abh-combo-btn]');
      if (!input) return;

      input.addEventListener('focus', function () {
        openCombo(combo);
      });
      input.addEventListener('input', function () {
        openCombo(combo);
        renderList(combo, input.value);
      });
      input.addEventListener('change', function () {
        commitInput(input);
      });
      input.addEventListener('blur', function () {
        window.setTimeout(function () {
          if (!combo.contains(document.activeElement)) {
            commitInput(input);
            closeAllCombos();
          }
        }, 120);
      });
      input.addEventListener('keydown', function (event) {
        var list = combo.querySelector('[data-abh-combo-list]');
        var options = list ? list.querySelectorAll('[data-value]') : [];
        var selected = list ? list.querySelector('.is-active') : null;
        if (event.key === 'Escape') {
          closeAllCombos();
          return;
        }
        if (event.key === 'Enter') {
          event.preventDefault();
          if (selected) input.value = selected.getAttribute('data-value');
          commitInput(input);
          closeAllCombos();
          return;
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (!list || list.hidden) openCombo(combo);
          options = combo.querySelectorAll('[data-value]');
          if (!options.length) return;
          var index = Array.prototype.indexOf.call(options, selected);
          if (event.key === 'ArrowDown') index = index < options.length - 1 ? index + 1 : 0;
          else index = index > 0 ? index - 1 : options.length - 1;
          options.forEach(function (option) {
            option.classList.remove('is-active');
          });
          options[index].classList.add('is-active');
          options[index].scrollIntoView({ block: 'nearest' });
        }
      });

      if (toggle) {
        toggle.addEventListener('mousedown', function (event) {
          event.preventDefault();
          if (input.disabled) return;
          var list = combo.querySelector('[data-abh-combo-list]');
          if (list && !list.hidden) closeAllCombos();
          else {
            input.focus();
            openCombo(combo);
            renderList(combo, '');
          }
        });
      }

      combo.addEventListener('mousedown', function (event) {
        var option = event.target.closest('[data-value]');
        if (!option) return;
        event.preventDefault();
        input.value = option.getAttribute('data-value');
        commitInput(input);
        closeAllCombos();
      });
    });

    document.addEventListener('mousedown', function (event) {
      if (hoursRoot.contains(event.target)) return;
      closeAllCombos();
    });
  }

  if (nameField) nameField.addEventListener('input', syncCartProperties);

  syncCartProperties();
});
